const newsList = document.querySelector('.news-list');

if (newsList) {
  // Detect variant
  const isArticleList = newsList.classList.contains('news-list--secondary');

  const config = {
    filterKey: isArticleList ? 'filteredArticleCategory' : 'filteredCategory',
    urlParams: [isArticleList ? 'filteredArticleCategory' : 'filteredCategory', 'pageNumber'],
  };

  const getExtraFormDataInput = (parent) => ({
    [config.filterKey]: getActiveCategoryButtonFilter(parent),
    initialCategories: parent.querySelector('[data-initial-categories]')?.value || '',
  });

  // Common handler for filtering & pagination
  const handleRequest = (parent, page = 1) => {
    axiosGetPaginateAndFilteredPosts(parent, page, config.urlParams, getExtraFormDataInput(parent));
  };

  // Category filter click
  attachEvent('.news-list .mod-filter__link', 'click', (ev) => {
    const parent = ev.target.closest('.news-list');
    const tab = ev.target.closest('.mod-filter__link');

    parent.querySelectorAll('.mod-filter__link').forEach((el) => el.classList.remove('is-active'));
    tab.classList.add('is-active');

    handleRequest(parent, 1);
  });

  // Pagination click
  attachEvent('.news-list .news-list__pagination .page-numbers', 'click', (ev) => {
    ev.preventDefault();
    const parent = ev.target.closest('.news-list');
    const page = ev.target.dataset.page || 1;

    handleRequest(parent, page);
  });
}
